// @flow
import { useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import { get } from 'lodash';
import { googleCalendarPageUrl } from '@context/googleCalendar';
import { openInBrowser } from '@helpers/cordova';
import { UserNotifications } from '@helpers/helpers';

// Conectar Google Agenda, from Ajustes › Google Agenda or from an online appointment (GoogleMeetCard): the API's page
// opens in the browser (the system browser in the apps), signed in with the user's token. `opened`: it did, so the
// screen tells them to come back. The button stays, for another try after a refusal or a closed browser.
const useGoogleCalendarConnect = (): { opened: boolean, connect: Function } => {
  const accessToken = useSelector(state => get(state, ['auth', 'token']));
  const [opened, setOpened] = useState(false);

  const connect = useCallback(() => {
    if (!openInBrowser(googleCalendarPageUrl(accessToken))) {
      UserNotifications.i18nTextAlert('error/browser_unavailable');
      return;
    }
    setOpened(true);
  }, [accessToken]);

  return { opened, connect };
};

export default useGoogleCalendarConnect;
